// Polyfills
import 'svgxuse';

import Accordion from './modules/accordion';
// import ActiveItem from "./modules/activeitem"
import AlphabeticIndexSmoothScroll from './modules/alphabeticIndexSmoothScroll';
import AudioControls from './modules/audioControls';
import BackToTop from './modules/backToTop';
import ContextDropdown from './modules/contextDropdown';
import FooterBottom from './modules/footerBottom';
import FullwidthSection from './modules/fullwidthSection';
import HeaderDropdown from './modules/headerDropdown';
import MainMenu from './modules/mainMenu';
import NotificationBar from './modules/notificationBar';
import ProfileDetails from './modules/profileDetails';
import SearchBar from './modules/searchBar';
import StickySidebar from './modules/stickySidebar';
//import StickyMenu from "./modules/stickyMenu";
import Submenu from './modules/submenu';
import Locator from './modules/locator';
import ToggleFilter from './modules/toggleFilter';
import WeeklyLetter from './modules/weeklyLetter';
import LoginButtonHelper from './modules/loginbuttonhelper';
import InputPasswordShow from './modules/inputPasswordShow';
import CtaReadMore from './modules/ctaReadMore';
import ImagePopup from './modules/imagePopup';

if (typeof Promise === 'undefined') {
  window.Promise = require('promise-polyfill');
}

if (typeof URLSearchParams === 'undefined') {
  window.URLSearchParams = require('url-search-params');
}

document.addEventListener('DOMContentLoaded', function () {
  new Accordion();
  new AlphabeticIndexSmoothScroll();
  new AudioControls();
  new BackToTop();
  new ContextDropdown();
  new FooterBottom();
  new FullwidthSection();
  new LoginButtonHelper();
  new MainMenu();
  new NotificationBar();
  new HeaderDropdown();
  new ProfileDetails();
  new SearchBar();
  new StickySidebar();
  new Submenu();
  new Locator();
  new ToggleFilter();
  new WeeklyLetter();
  new InputPasswordShow();
  new CtaReadMore();
  new ImagePopup();
});
